<template>
    <div class="language-selector">
        Language:&nbsp
        <router-link :class="getClass(room, lang)" :to="getUrl(room, lang)" tag="a" :key="lang.link" v-for="lang in languages" >
            {{ lang.display }}&nbsp
        </router-link>
    </div>
</template>

<script>

  export default {
    name:'languageselector',
    props: ["room", "currentLanguage"],
      mounted() {
        this.$el.style.cssText = `
          transform-origin: center;
          will-change: transform;
        `
      },
      data() {
        return {
          languages: [{
              link: "",
              display: "US"
          },
          {
              link: "/de",
              display: "DE"
          },
          {
              link: "/es",
              display: "ES"
          },
          {
              link: "/fr",
              display: "FR"
          },
          {
              link: "/it",
              display: "IT"
          }]
        }
      },
      methods: {
          getClass(roomName, lang) {
            let curLangKey = "US";
            switch(this.currentLanguage) {
                case "spanish": curLangKey = "ES"; break;
                case "german": curLangKey = "DE"; break;
                case "italian": curLangKey = "IT"; break;
                case "french": curLangKey = "FR"; break;
                default: curLangKey = "US"; break;
            }
            if(curLangKey === lang.display) {
                return "selected";
            }
            return "";
          },
          getUrl(roomName, lang) {
              return '/walkthrough' + lang.link + '/' +  roomName;
          }
    }
}
</script>

<style scoped>
.language-selector {
    display: flex;
    text-align: center;
    color: white;
    width: 150px;
    margin: auto;
    margin-top: 20px;
    justify-content: space-between;
}
.language-selector .selected {
    color: white;
}
.language-selector :not(.selected) {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/langaugeselector.vue